import { authFetch } from "../utils/authFetch";
import { baseUrl } from "../utils/requestUrl";

// The scales this organization's checklists may pick from: the global ones plus
// its own. Open to any member of the organization, unlike GET /scoringScales,
// which is admin-only.
export const fetchScoringScalesForOrganization = async (organizationId) => {
  const response = await authFetch(
    `${baseUrl}/scoringScales/organizations/${organizationId}`
  );
  return response.json();
};
